import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SimpleDialog } from '../../models/simple-dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { ScrollActivityDirective } from '../directives/scroll-activity.directive';

@Component({
  selector: 'app-basic-dialog',
  templateUrl: './basic-dialog.component.html',
  styleUrls: ['./basic-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, FormsModule, ScrollActivityDirective],
})
export class BasicDialogComponent {
  appUIComponent: SimpleDialog;
  selectedSetArea: string = '';
  selectedCountry: string = '';
  textInputValue: string = '';
  
  constructor(
    public dialogRef: MatDialogRef<BasicDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SimpleDialog,
    public router: Router
  ) {
    this.appUIComponent = data;
    dialogRef.disableClose = true;
  }

  onCancel(): void {
    // Close modal with false result to indicate cancellation
    this.dialogRef.close(false);
  }

  formatCountryName(country: string): string {
    if (!country) return country;
    const withSpaces = country.replace(/_/g, ' ');
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
  }

  onConfirm(): void {
    if (this.appUIComponent.redirect) {
      this.navigate(this.appUIComponent.redirect);
    } else {
      // Close modal with result including dropdown/text selections
      if (this.appUIComponent.dropdowns) {
        this.dialogRef.close({
          confirmed: true,
          setArea: this.selectedSetArea || null,
          country: this.selectedCountry || null
        });
      } else if (this.appUIComponent.textInput) {
        this.dialogRef.close({
          confirmed: true,
          textValue: this.textInputValue || null
        });
      } else {
        this.dialogRef.close(true);
      }
    }
  }

  navigate(url: string): void {
    if (!url) {
      throw new Error('url is undefined');
    }

    this.closeModal();
    this.router.navigate([url]);
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
